import { useMemo } from "react";

import {
  useOfflineStatus as useFullOfflineStatus,
} from "@/hooks/useOnlineSync";

export function useOfflineStatus() {
  const {
    isOnline,
    outboxCount,
  } = useFullOfflineStatus();

  return useMemo(
    () => ({
      isOnline,
      pendingSync:
        outboxCount,
    }),
    [
      isOnline,
      outboxCount,
    ]
  );
}